import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Button from 'src/components/Button';
import Toast from 'src/components/Toast';
import { IPaginationParams, IPaginationResponse } from 'src/models/interfaces/pagination';
import { enStatusCode, IReservation } from 'src/models/interfaces/reservation';
import fleetsService from 'src/service/fleetsService';
import { Results } from 'src/types/IOrder';
import GridItem from './gridItem';
import TablePagination from './pagination';
import { GridContainer, Header, MessageTD, Table, TBody, TFoot, THead, CheckboxContainer } from './styles';

interface IProps {
  data: IPaginationResponse<Results>;
  error: boolean;
  loading: boolean;
  params: IPaginationParams;
  mergeParams: (newParams: Partial<IPaginationParams>) => void;
}

const DataGrid = (props: IProps) => {
  const { data, error, loading, params, mergeParams } = props;
  const toast = Toast();

  const { total, results } = data || ({ total: 0, results: [] } as typeof data);

  const notCanceled = useMemo((): IReservation[] => {
    return (data?.results as any)?.filter((r: any) => r.statusCode !== enStatusCode.canceled);
  }, [data]);

  const handleExport = useCallback(() => {
    fleetsService
      .ordersReport(params)
      .then(({ data }) => {
        const url = window.URL.createObjectURL(data);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'Relatório de Solicitações de compra.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => toast.error());
  }, [params]);

  return (
    <>
      <Header>
        <div className='right'>
          <Button fill={false} onClick={handleExport}>
            Exportar dados
          </Button>
        </div>
      </Header>
      <GridContainer>
        <Table>
          <THead>
            <tr>
              <th>Nome Completo</th>
              <th>GPID</th>
              <th>Data de Admissão</th>
              <th>Nível</th>
              <th>Prioridade</th>
              <th>Veículo</th>
              <th>Ano</th>
              <th>Placa</th>
              <th>Pedido</th>
              <th>Data de Solicitação</th>
              <th>Status</th>
            </tr>
          </THead>
          <TBody>
            {error ? (
              <tr>
                <MessageTD>Houve um erro ao obter os registros.</MessageTD>
              </tr>
            ) : loading ? (
              <tr>
                <MessageTD>Carregando...</MessageTD>
              </tr>
            ) : results.length > 0 ? (
              results.map(d => (
                <GridItem key={d.id} item={d} />
              ))
            ) : (
              <tr>
                <MessageTD>Nenhum registro encontrado.</MessageTD>
              </tr>
            )}
          </TBody>
          <TFoot>
            <tr>
              <TablePagination
                colSpan={30}
                total={total}
                disabled={loading}
                paginationParams={params}
                onChange={mergeParams}
              />
            </tr>
          </TFoot>
        </Table>
      </GridContainer>
    </>
  );
};

export default DataGrid;
